import { render, staticRenderFns } from "./LandownerStatTab.vue?vue&type=template&id=30b31f3c"
import script from "./LandownerStatTab.vue?vue&type=script&lang=js"
export * from "./LandownerStatTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports